import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import 'chart.js'
import {LineChart} from 'react-chartkick'
import Select from "react-select";

export default class ScoresChartLine extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.books = [];
		this.state.calls = [];
		this.state.avgs = [];
		this.state.users = [];
		this.state.selectedUsers = [];
		this.state.start_date = moment(Date.now()).format()
		this.state.end_date = moment(Date.now()).format()
		this.state.avgAdded = false;
	}

	async componentDidMount() {
		await this.getScores();
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.date !== prevProps.date && this.props.date && prevProps.date) {
			if (this._getTimeout) {
				clearTimeout(this._getTimeout)
			}
			this._getTimeout = setTimeout(async () => {
				this.state.custom_date = false;
				this.setState({loading: true, books: [], calls: [], avgs: []})
				await this.getScores();
				this.setState({loading: false})
			}, 500)
		}
		if (this.props.filteredUser !== prevProps.filteredUser) {
			this.state.selectedUsers = this.state.users.filter((item) => item.value === this.props.filteredUser)
		}
		if (Array.isArray(this.state.selectedUsers) && this.state.selectedUsers.length === 1 && !this.state.avgAdded) {
			this.state.avgAdded = true;
			let {books, calls, avgs} = this.state;

			let user = this.state.selectedUsers[0].label;

			let strim = 20;
			let etrim = 20;

			[books, calls, avgs].forEach((data, index) => {
				let _strim = 0;
				let _etrim = 0;
				if (data[data.length - 1].name === user + ' Daily Average') {
					data.splice(data.length - 1, 1)
				}
				let found = data.filter((item) => item.name === user)[0];
				let foundData = Object.keys(found.data).map((key) => {
					return found.data[key]
				});
				let split = false;
				foundData.forEach((item) => {
					if (split) {
						return;
					}
					if (parseFloat(item) == 0) {
						_strim++;
					} else {
						split = true;
					}
				});
				split = false;
				foundData.reverse().forEach((item) => {
					if (split) {
						return;
					}
					if (parseFloat(item) == 0) {
						_etrim++;
					} else {
						split = true;
					}
				});
				foundData = foundData.filter((item) => {return parseFloat(item) > 0})
				let total = foundData.reduce((acc, obj) => {
					return acc + parseFloat(obj)
				}, 0);
				let rounded = (Math.round(((total / foundData.length) + Number.EPSILON) * 100) / 100);
				let _data = {};
				Object.keys(found.data).forEach((key) => {
					_data[key] = rounded;
				})
				data = [...data, {name: user + ' Daily Average',
					data: _data
				}]

				if (_strim < strim) {
					strim = _strim;
				}

				if (_etrim < etrim) {
					etrim = _etrim;
				}

				if (index === 0) {
					books = data;
				} else if (index === 1) {
					calls = data;
				} else {
					avgs = data;
				}
			})

			this.setState({books, calls, avgs, strim: strim === 20 ? null : strim, etrim: etrim === 20 ? null : etrim})
		} else if ((Array.isArray(this.state.selectedUsers) && this.state.selectedUsers.length !== 1) || this.state.selectedUsers === 'empty') {
			if (this.state.strim || this.state.etrim) {
				await this.getScores(this.state.custom_date ?? false);
			}
			let {books, calls, avgs} = this.state;

			[books, calls, avgs].forEach((data, index) => {
				if (data.filter((item) => item.name.includes(' Daily Average')).length > 0) {
					data = data.filter((item) => !item.name.includes(' Daily Average'))
					if (index === 0) {
						this.setState({strim: null, etrim: null})
						this.setState({books: data})
					} else if (index === 1) {
						this.setState({strim: null, etrim: null})
						this.setState({calls: data})
					} else {
						this.setState({strim: null, etrim: null})
						this.setState({avgs: data})
					}
				}
			})
		}
	}

	getScores = async (custom_date) => {
		this.state.custom_date = custom_date ?? false;
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_SCORES_LINE_CHART';
		model.filter = {
			'day': this.props.date,
			'start_date': custom_date ? this.state.start_date : null,
			'end_date': custom_date ? this.state.end_date : null
		}
		model.limit = 100;
		this.linedata = await model.submit(null, this.read);
		this.linedata = this.linedata.items;
		let users = this.linedata?.users ?? [];
		let selectedUsers = this.state.selectedUsers !== 'empty' ? users.filter((item) => this.state.selectedUsers.map((item) => item.label).includes(item.label)) : 'empty'
		this.setState({
			books: this.linedata?.books ?? [],
			calls: this.linedata?.calls ?? [],
			avgs: this.linedata?.avg_time ?? [],
			users,
			selectedUsers,
			avgAdded: false,
			strim: null,
			etrim: null
		});
	}

	handleUsers = async (value) => {
		let users = [];
		if (value && value.length > 0) {
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i]);
			}
			this.setState({avgAdded: false, selectedUsers: users.sort((a, b) => a.label.localeCompare(b.label))})
		} else {
			this.setState({avgAdded: false, selectedUsers: 'empty'});
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}

	handleWeekSet = async (week) => {
		let moment_date_start = moment();
		let moment_date_end = moment();
		let moment_day = moment_date_start.day();
		let start, end = null;
		if (week === "last") {
			//last sunday
			start = moment_date_start.subtract(moment_day + 7, "days");
			//last saturday
			end = moment_date_end.subtract(moment_day + 1, "days");
		} else if (week === "this") {
			//last sunday
			start = moment_date_start.subtract(moment_day, "days");
			//last saturday
			end = moment_date_end.add(6 - moment_day, "days");
		} else if (week === "30") {
			start = moment_date_start.subtract(moment_day + 30, "days");
			end = moment_date_end;
		} else if (week === "90") {
			start = moment_date_start.subtract(moment_day + 90, "days");
			end = moment_date_end;
		}
		await this.setState({
			start_date: start.format('YYYY-MM-DD'),
			end_date: end.format('YYYY-MM-DD')
		});
		this.props.setStartDate(this.state.start_date);
		this.props.setEndDate(this.state.end_date);
		await this.getScores(true);
	}

	formatChartData = (key) => {
		let AVG = this.state[key].filter((item) => item.name.includes('Average'))
		let FILTERED = this.state[key].filter((item) => this.state.selectedUsers !== 'empty' && this.state.selectedUsers.length > 0 ? this.state.selectedUsers.map((item) => item.label).includes(item.name) : this.state.users.map((item) => item.label).includes(item.name))
		let returnable;
		if (this.state.selectedUsers !== 'empty' && this.state.selectedUsers.length === 1 && this.state.strim && this.state.etrim) {
			returnable = [...AVG, ...FILTERED];
			returnable = returnable.map((item) => {
				let keys = Object.keys(item.data);
				keys.splice(0, this.state.strim);
				keys.splice(-this.state.etrim, this.state.etrim);
				let _data = {}
				keys.map((key) => _data[key] = item.data[key])
				item.data = _data;
				return item;
			})
		} else {
			returnable = [...AVG, ...FILTERED];
		}
		return returnable;
	}

	render() {
		const {loading} = this.state;

		return (<div className={'box-body'}>
			<Framework.Elements.LoadingSpinner isLoading={loading}/>
			<Card>
				<CardContent>

					<div className={'row pb-4'}>
						<div className={'col-4'}>
							<Button onClick={() => {
								this.setState({showDateRange: true})
							}}>
								Select Date Range
							</Button>
						</div>
						<div className={'col-4'}>
							<Select
								key={this.state.users}
								placeholder={"User Select"}
								isMulti
								isClearable
								value={this.state.selectedUsers !== 'empty' ? this.state.selectedUsers : []}
								onChange={this.handleUsers}
								options={this.state.users}
							/>
						</div>
					</div>

					<div className={'row'}>
						<div className={'col-4 d-flex justify-content-center'}>
							{this.state.books.length > 0 ? <div style={{'flexDirection': 'column', 'width': '100%', 'display': 'flex'}}>
								<b style={{'alignSelf': 'center'}}>BOOKS</b>
								{/*filtering the data below is basically to make sure the average is first then the rest*/}
								<LineChart key={this.state.selectedUsers}
								           colors={["#FF0000", "#FF0000", "#2B81C2", "#5D16EE", "#EE16B1", "#B1EE16", "#EE5316", "#EEBF16", "#2B36C2", "#B72BC2", "#4C14B1", "#B14C14", "#14B14C", "#B19514", "#0f3f04", "#bcf778", "#032335", "#faa3ca", "#ae0a7f", "#875008"]}
								           data={this.formatChartData('books')}/>
							</div> : <b> There is no data for the books chart. </b>}
						</div>

						<div className={'col-4 d-flex justify-content-center'}>
							{this.state.calls.length > 0 ? <div style={{'flexDirection': 'column', 'width': '100%', 'display': 'flex'}}>
								<b style={{'alignSelf': 'center'}}>CALLS</b>
								{/*filtering the data below is basically to make sure the average is first then the rest*/}
								<LineChart
									colors={["#FF0000", "#FF0000", "#2B81C2", "#5D16EE", "#EE16B1", "#B1EE16", "#EE5316", "#EEBF16", "#2B36C2", "#B72BC2", "#4C14B1", "#B14C14", "#14B14C", "#B19514", "#0f3f04", "#bcf778", "#032335", "#faa3ca", "#ae0a7f", "#875008"]}
									data={this.formatChartData('calls')}/>
							</div> : <b> There is no data for the calls chart. </b>}
						</div>

						<div className={'col-4 d-flex justify-content-center'}>
							{this.state.avgs.length > 0 ? <div style={{'flexDirection': 'column', 'width': '100%', 'display': 'flex'}}>
								<b style={{'alignSelf': 'center'}}>AVG TIME</b>
								{/*filtering the data below is basically to make sure the average is first then the rest*/}
								<LineChart
									colors={["#FF0000", "#FF0000", "#2B81C2", "#5D16EE", "#EE16B1", "#B1EE16", "#EE5316", "#EEBF16", "#2B36C2", "#B72BC2", "#4C14B1", "#B14C14", "#14B14C", "#B19514", "#0f3f04", "#bcf778", "#032335", "#faa3ca", "#ae0a7f", "#875008"]}
									data={this.formatChartData('avgs')}/>
							</div> : <b> There is no data for the avgs chart. </b>}
						</div>
					</div>
				</CardContent>
			</Card>
			<Modal
				isOpen={this.state.showDateRange}
				toggle={() => this.handleToggleModal('showDateRange')}
				size={"lg"}
				backdrop={true}
			>
				<ModalHeader cssModule={{'modal-title': 'w-100 d-flex justify-content-between'}}>
					<span>
						Select Start and End Date
					</span>
					<span>
						<Button onClick={() => {
							this.handleWeekSet('last')
							this.handleToggleModal('showDateRange')
						}}>
							Last Week
						</Button> &nbsp;&nbsp;&nbsp;
						<Button onClick={() => {
							this.handleWeekSet('this')
							this.handleToggleModal('showDateRange')
						}}>
							This Week
						</Button> &nbsp;&nbsp;&nbsp;
						<Button onClick={() => {
							this.handleWeekSet('30')
							this.handleToggleModal('showDateRange')
						}}>
							Last 30 Days
						</Button> &nbsp;&nbsp;&nbsp;
						<Button onClick={() => {
							this.handleWeekSet('90')
							this.handleToggleModal('showDateRange')
						}}>
							Last 90 Days
						</Button>
					</span>
				</ModalHeader>
				<ModalBody>
					<div className={'row'}>
						<div className={'col-6'}>
							<div>
								Start Date &nbsp;&nbsp;
								<Button onClick={() => {
									this.handleToggleModal('showStartDate')
								}}>
									{moment(this.state.start_date).format('dddd MMM D')}
								</Button>
							</div>
						</div>
						<div className={'col-6'}>
							<div>
								End Date &nbsp;&nbsp;
								<Button onClick={() => {
									this.handleToggleModal('showEndDate')
								}}>
									{moment(this.state.end_date).format('dddd MMM D')}
								</Button>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color={'primary'} onClick={() => {
						this.handleToggleModal('showDateRange')
						this.props.setStartDate(this.state.start_date);
						this.props.setEndDate(this.state.end_date);
						this.getScores(true)
					}}>
						OK
					</Button>
					<Button color={'secondary'} onClick={() => {
						const today = moment(Date.now()).format('YYYY-MM-DD');
						this.setState({start_date: today, end_date: today})
						this.handleToggleModal('showDateRange')
					}}>
						Cancel
					</Button>
				</ModalFooter>
			</Modal>
			<Modal
				isOpen={this.state.showStartDate}
				toggle={this.toggleClose}
				size={"sm"}
				backdrop={true}
				style={{display: "none"}}
			>
				<ModalBody>
					<Framework.Elements.Date
						label={"Custom Date"}
						value={this.state.start_date}
						update={(name, date) => {
							if (moment(date).isAfter(moment(this.state.end_date))) {
								alert('Start date may not be after the end date.')
								this.handleToggleModal('showStartDate');
								return;
							}
							this.state.start_date = moment(date).format('YYYY-MM-DD');
							this.handleToggleModal('showStartDate');
						}}
						open={this.state.showStartDate}
						clearable={false}
						cancelLabel={''}
					/>
				</ModalBody>
			</Modal>
			<Modal
				isOpen={this.state.showEndDate}
				toggle={this.toggleClose}
				size={"sm"}
				backdrop={true}
				style={{display: "none"}}
			>
				<ModalBody>
					<Framework.Elements.Date
						label={"Custom Date"}
						value={this.state.end_date}
						update={(name, date) => {
							if (moment(date).isBefore(moment(this.state.start_date))) {
								alert('End date may not be before the start date.')
								this.handleToggleModal('showEndDate');
								return;
							}
							this.state.end_date = moment(date).format('YYYY-MM-DD');
							this.handleToggleModal('showEndDate');
						}}
						open={this.state.showEndDate}
						clearable={false}
						cancelLabel={''}
					/>
				</ModalBody>
			</Modal>
		</div>)
	}
}
